module.exports = __webpack_public_path__ + "img/undraw_Notebook_re_id0r.69457520.svg";